<template>
  <div class="userinfo-container all-box">
    <Header :title="title" :canSubmit="canSubmit" :userJoin="userJoin" />
    <section class="userinfo-bm-input">
      <div class="userinfo-wrap">
        <el-avatar
          :size="100"
          :src="
            storage.getItem('headimgurl')
              ? 'https://clubs.xinmin.cn/' + storage.getItem('headimgurl')
              : 'https://clubs.xinmin.cn/' + wx.headimgurl
          "
          :fit="fits[2]"
          @error="errorHandler"
          class="userinfo-author"
        >
          <img src="@/assets/author.png" style="object-fit: contain" />
        </el-avatar>
        <el-form
          :model="userForm"
          :rules="rules"
          label-width="80px"
          :label-position="labelPosition"
          ref="userForm"
        >
          <div class="userinfo-input">
            <el-form-item label="姓名" prop="username">
              <el-input
                v-model="userForm.username"
                placeholder="请填写姓名"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="userinfo-input">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="userForm.phone"
                placeholder="请填写手机号"
                maxlength="11"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="userinfo-input">
            <el-form-item label="地区">
              <el-select v-model="userForm.province" placeholder="请选择地区">
                <el-option
                  v-for="(item, key) in userForm.provinces"
                  :key="key"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="userinfo-input" v-if="userForm.province == '上海市'">
            <el-form-item label="区域" prop="area">
              <el-select v-model="userForm.area" placeholder="请选择区域">
                <el-option
                  v-for="(item, key) in userForm.areas"
                  :key="key"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="userinfo-input">
            <el-form-item label="收寄地址" prop="address">
              <el-input
                v-model="userForm.address"
                placeholder="请填写收寄地址"
                clearable
              ></el-input>
              <p class="input-tishi" style="padding-left: 4px">
                请填写真实地址，确保您能接收我们的礼品。
              </p>
            </el-form-item>
          </div>
          <div class="userinfo-btn">
            <el-button
              type="danger"
              @click="userJoin('userForm')"
              :disabled="canSubmit"
              class="userInfoSubmit"
              >提交信息
            </el-button>
          </div>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
import Header from "@/components/util/Header";

import qs from "qs";

export default {
  name: "Index",
  data() {
    return {
      title: "设置",
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      labelPosition: "left",
      wx: {
        uid: 0,
        openid: "",
        nickname: "",
        headimgurl: "",
        userToken: "",
      },
      userForm: {
        username: "",
        phone: "",
        province: "",
        provinces: ["上海市", "其他"],
        area: "",
        areas: [
          "黄浦区",
          "长宁区",
          "杨浦区",
          "徐汇区",
          "松江区",
          "青浦区",
          "普陀区",
          "浦东新区",
          "闵行区",
          "静安区",
          "金山区",
          "虹口区",
          "奉贤区",
          "崇明区",
          "宝山区",
          "嘉定区",
        ],
        address: "",
      },
      rules: {
        username: [{ required: false, message: "请填写姓名", trigger: "blur" }],
        phone: [{ required: false, message: "请填写手机号", trigger: "blur" }],
        area: [{ required: false, message: "请选择区域", trigger: "blur" }],
        address: [
          { required: false, message: "请填写收寄地址", trigger: "blur" },
        ],
      },
      userForms: null,
      optKey: 0,
      canSubmit: true,
      storage: window.localStorage,
    };
  },
  mounted() {
    this.wx.uid = this.storage.getItem("uid");
    this.wx.userToken = this.storage.getItem("usertoken");
    this.getInfo();
  },
  methods: {
    errorHandler() {
      return true;
    },
    selectDep(val) {
      for (var key in this.userForm.provinces) {
        if (val == this.userForm.provinces[key]) {
          this.optKey = key;
        }
      }
    },
    getInfo() {
      this.$axios
        .get(`/wxindex/user/getinfo.html`, {
          params: {
            uid: this.wx.uid,
            usertoken: this.wx.userToken,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.userForm.username = response.data.userinfo.realname;
            this.userForm.phone = response.data.userinfo.phone;
            this.userForm.province = response.data.userinfo.province;
            this.userForm.area = response.data.userinfo.area;
            this.userForm.address = response.data.userinfo.address;
            this.wx.headimgurl = response.data.userinfo.avatar;
            this.canSubmit = false;
          } else {
            window.location.href =
              "https://clubs.xinmin.cn/dzclub/index.html#/auth";
          }
        });
    },
    userJoin(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              `/wxindex/user/edit.html`,
              qs.stringify({
                uid: this.wx.uid,
                usertoken: this.wx.userToken,
                realname: this.userForm.username,
                phone: this.userForm.phone,
                province: this.userForm.province,
                area: this.userForm.area,
                address: this.userForm.address,
              })
            )
            .then((response) => {
              this.userForms = response.data;
              if (this.userForms.status) {
                this.canSubmit = true;
                this.$message.success({
                  message: this.userForms.message,
                  type: "success",
                  center: true,
                  offset: 90,
                  duration: 1500,
                  customClass: "message-class",
                });
                setTimeout(() => {
                  this.$router.push({
                    name: "Home",
                  });
                }, 1500);
              } else {
                this.canSubmit = true;
                this.$message.warning({
                  message: this.userForms.message,
                  type: "warning",
                  center: true,
                  offset: 90,
                  duration: 1500,
                  customClass: "message-class",
                });
                setTimeout(() => {
                  this.canSubmit = false;
                }, 1500);
              }
            });
        } else {
          return false;
        }
      });
    },
  },
  components: {
    Header,
  },
};
</script>

<style scoped>
.userinfo-container {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.userinfo-container .header-wrap {
  background-color: var(--f56c6c);
  color: var(--fff);
}

.userinfo-bm-input {
  position: relative;
  margin: auto;
  overflow: hidden;
  padding-top: 70px;
  background-color: var(--fff);
}

.userinfo-wrap {
  padding: 0 5%;
  margin: auto;
}

.userinfo-code-wrap {
  display: -webkit-flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 20px;
}

.codeLabelWrap img {
  display: block;
  margin: auto;
  width: 20px;
  height: 17px;
}

.codeLabelWrap label {
  display: block;
  color: var(--ee5f5c);
  font-weight: 600;
  margin: 10px auto 0;
  width: 80px;
}

.userinfo-author {
  margin-bottom: 20px;
}

.userinfo-btn {
  width: 55%;
  margin: auto;
  padding: 10px 0 20px;
}

.userInfoSubmit {
  width: 100%;
}
</style>